// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { AuthEffects } from './store/effects';
import * as fromAuth from './store/reducer';

// SERVICES
import { AuthStoreService } from './auth-store.service';
import { AuthService } from './services/auth.service';

/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['user'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure auth ngrx related stuff.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) configure auth store ng module
 */
@NgModule({
  imports: [
    StoreModule.forFeature('auth', fromAuth.reducer, { metaReducers }),
    EffectsModule.forFeature([AuthEffects]),
  ],
  declarations: [],
  providers: [
    AuthService,
    AuthStoreService,
  ],
})
export class AuthStoreModule { }
